export const SKELETON_COUNT = {
  FORECAST_SECTION: 4,
  LOCATION_CARD: 4,
  FORECAST_ITEM: 9,
  HOURLY_FORECAST_SECTION: 4,
  HOURLY_FORECAST_ITEM: 6,
  GRAPH_ITEM: 4
}
